var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.showUserAuth},on:{"update:visible":function($event){_vm.showUserAuth=$event}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"button",on:{"click":_vm.toUserAuth}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }